import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  ConnectDeclineReason,
  IConnectContact,
} from '@epicuro-next/data/connect';
import { CONNECT_CALL_NOTIFICATION_DISMISS_TIME } from '@epicuro-next/platform/configuration';
import { EMPTY, of, Subject } from 'rxjs';
import { delay, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'epc-connect-call-notification',
  templateUrl: './call-notification.component.html',
  styleUrls: ['./call-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CallNotificationComponent implements OnInit, OnDestroy {
  @Input()
  public contact: IConnectContact;

  @Output()
  public accept = new EventEmitter();

  @Output()
  public decline = new EventEmitter<string>();

  public declineReasons = ConnectDeclineReason;

  private destroy$ = new Subject<void>();

  public ngOnInit() {
    this.missCallAfterDelay();
  }

  public ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public missCallAfterDelay() {
    of(EMPTY)
      .pipe(
        delay(CONNECT_CALL_NOTIFICATION_DISMISS_TIME),
        takeUntil(this.destroy$),
      )
      .subscribe(() => this.decline.emit(ConnectDeclineReason.TIMEOUT));
  }
}
